import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { generateGlobalColumns, IDataGridConfig, generateBasicColumn } from '@ts/storybook';
import { CDeviceType, IConfigComponent } from '@ts/ui-models';

interface DeviceTypeProps {
  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'deviceTypes',
  aclId: 'taDeviceType',
  entity: 'deviceType',
  fetchURL: '/api/deviceTypes',
  crudURL: '/api/deviceType',
  mainClass: CDeviceType,
};

const DeviceTypes: React.FC<DeviceTypeProps> = props => {
  const { configComponent = defaultConfigComponent } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  //#region Functions
  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });
    return [
      globalCells.id(),
      globalCells.name(),
      generateBasicColumn({ field: 'manufacturer' }, { field: 'manufacturer' }),
      generateBasicColumn({ field: 'partNumber' }, { field: 'partNumber' }),
      {
        field: 'category',
        headerName: 'Category',
        valueGetter: (value, row, column) => {
          return row?.deviceTypeCategories.map(v => v.category.name).join('; ') ?? '';
        },
      },
    ];
  }, [props, configComponent]);
  //#endregion

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      dataGridMode={'server'}
      //From grandpa
      inheritedProps={props.inheritedProps}
    />
  );
};

export default DeviceTypes;
